import SelectPage from '../select/src/select-page';

SelectPage.install = function(Vue) {
  Vue.component(SelectPage.name,SelectPage);
};

export default SelectPage;



// WEBPACK FOOTER //
// ./src/components/select-page/index.js